module.exports = __webpack_public_path__ + "static/media/stm-21st-tablet-1476x114-@2x.a32ac41a.png";